module.exports = __webpack_public_path__ + "static/media/recenterIcon.e3d8277d.svg";